import {  Form, Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import FormikInput from "../../../components/FormikFieldCustom";
import ButtonLoader from "../../../components/ButtonLoader";
import { UpdateUserProfile } from "../../../services/auth.service";
import { StatusCodes } from "http-status-codes";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
  GetAdminUserDetail,
  GetUserDetails,
  UpdateAdminUserProfile,
} from "../../../services/user.service";
import { LoggedInUserContext } from "../../../context/loggedInUserContext";
import { Roles } from "../../../types/role.enums";
import GooglePlacesAutoComplete from "../../../components/GooglePlacesAutoComplete";
interface IUserProfile {
  first_name: string;
  last_name: string;
  auctioner_licenses: string;
  city: string;
  company_name: string;
  country: string;
  created_at: string;
  id: number;
  userId: string;
  state: string;
  address: string;
  terms_conditions: null;
  updated_at: string;
  user_id: number;
  website: string;
  zip: string;
}
const MyProfile = () => {
  const naviagte = useNavigate();
  const [userProfile, setUserProfile] = useState<IUserProfile | null>(null);
  const { loggedInUserContext } = useContext(LoggedInUserContext);
  const { id } = useParams();
  const getUserDetails = async () => {
    const response =
      loggedInUserContext?.role_name === Roles.SUPER_ADMIN
        ? await GetAdminUserDetail(id)
        : await GetUserDetails();
    if (response.status && response.status_code === StatusCodes.OK) {
      setUserProfile({
        userId: response?.data?.id,
        ...response?.data?.user_profile,
        address: response?.data?.user_profile?.street_address,
        first_name: response?.data?.first_name,
        last_name: response?.data?.last_name,
      });
    }
  };
  useEffect(() => {
    getUserDetails();
  }, []);

  return (
    <div>
      <h1 className="text-center">Auctioneer Profile</h1>
      <Formik
        onSubmit={async (values) => {
          const newValues = { ...values, street_address: values.address };
          const response =
            loggedInUserContext?.role_name === Roles.SUPER_ADMIN
              ? await UpdateAdminUserProfile(newValues, userProfile?.userId)
              : await UpdateUserProfile(newValues, userProfile?.userId);
          if (response.status_code === StatusCodes.OK && response.status) {
            naviagte("/");
            toast.success(response.message);
          } else {
            toast.error(response.message);
          }
        }}
        enableReinitialize
        initialValues={userProfile!}
      >
        {({ setFieldValue, isSubmitting }) => (
          <Form className="mt-4">
            <div className="grid md:grid-cols-2 gap-4 xs:grid-cols-1 sm:grid-cols-2">
              <FormikInput name="first_name" label="First Name" />
              <FormikInput name="last_name" label="Last Name" />
              <FormikInput name="company_name" label="Company Name" />
              <div>
                <label className="block mb-2 text-sm text-gray-800">
                  Address
                </label>
                <GooglePlacesAutoComplete setFieldValue={setFieldValue}  />
              </div>
              <FormikInput
                name="city"
                label="City"
                autoComplete="address-level2"
              />
              <FormikInput
                name="state"
                label="State"
                autoComplete="address-level3"
              />
              <FormikInput
                name="country"
                label="Country"
                autoComplete="country-name"
              />
              <FormikInput name="zip" label="Zip" />
              <FormikInput name="website" label="Website" />
            </div>
            <button
              type="submit"
              className="mt-4 border-2 px-1 border-gray-600 bg-gray-400 grid grid-cols-1"
            >
              {isSubmitting ? (
                <>
                  <ButtonLoader />
                  Loading...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MyProfile;
